import {
  TextB,
  TextItalic,
  Quotes,
  ListNumbers,
  ListBullets,
  TextHOne,
  TextHTwo,
  TextHThree,
  TextHFour
} from '@phosphor-icons/react'


export const blockTypes = [
  { label: 'H1', style: 'header-one', icon: TextHOne },
  { label: 'H2', style: 'header-two', icon: TextHTwo },
  { label: 'H3', style: 'header-three', icon: TextHThree },
  { label: 'H4', style: 'header-four', icon: TextHFour },
  { label: 'Blockquote', style: 'blockquote', icon: Quotes },
  { label: 'UL', style: 'unordered-list-item', icon: ListBullets },
  { label: 'OL', style: 'ordered-list-item', icon: ListNumbers }
]

export const inlineStyles = [
  { label: 'Bold', style: 'BOLD', icon: TextB },
  { label: 'Italic', style: 'ITALIC', icon: TextItalic }
]
